var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReceiptPlus = function SvgReceiptPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.4v17.3c0 .4.5.5.7.3l.7-1c.2-.2.4-.2.6 0l1.1 1.3c.2.2.4.2.6 0L7.9 18c.2-.2.4-.2.6 0l1.1 1.3c.2.2.4.2.6 0l1.1-1.3c.2-.2.4-.2.6 0l.3.3c-.1-.4-.2-.8-.2-1.3v-.5h-.5c-1.7 0-3-1.3-3-3s1.3-3 3-3h.5V10c0-1.7 1.3-3 3-3 .8 0 1.5.3 2 .8V1.4c0-.4-.5-.5-.7-.3l-.7.9c-.2.2-.4.2-.6 0L13.9.7c-.2-.2-.4-.2-.6 0L12.1 2c-.2.2-.4.2-.6 0L10.4.7c-.2-.2-.4-.2-.6 0L8.6 2c-.2.1-.5.1-.7 0L6.8.6c-.2-.2-.4-.2-.6 0L5.1 2c-.2.1-.5.1-.7 0l-.7-.9C3.5.8 3 1 3 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9c.6 0 1 .4 1 1v2.5h2.5c.6 0 1 .4 1 1s-.4 1-1 1H16V17c0 .6-.4 1-1 1s-1-.4-1-1v-2.5h-2.5c-.6 0-1-.4-1-1s.4-1 1-1H14V10c0-.6.4-1 1-1z"
  })));
};
export default SvgReceiptPlus;